import { EsquireClient } from "@/types/clients/esquire";
import BookingContract, {
  IBookingContract
} from "@/types/clients/esquire/data/booking/booking-contract";

export default class GetExtensionData {
  constructor(private client: EsquireClient) {}

  public async send(reservationId: string, contractIds: Array<string>, newDepartureDate: string): Promise<Array<BookingContract>> {
    const url = await this.client.fetchUrlFromSession("extension-data");
    const data = {
      reservation_id: reservationId,
      contract_ids: contractIds,
      new_departure_date: newDepartureDate
    };

    const response = await this.client.fetch(
      () => new URL(url), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      }
    );

    if (!response.ok) {
      await this.client.logOutIfForbidden(response.status);
      return [];
    }
    const result = await response.json();
    return result.map((bookingContract: IBookingContract) => new BookingContract(bookingContract));

  }
}
